export async function getFileFromUrl(url: string, defaultType = 'image/jpeg') {
  const response = await fetch(url);
  const data = await response.blob();
  return new File([data], url, {
    type: response.headers.get('content-type') || defaultType,
  });
}
